<template lang="pug">
  include ./../../../mixins
  div.get-form
    .loading-mask(v-show="isLoading")
      .custom-loader
    validation-observer(
      ref="observer",
      tag="form",
      class="form",
      @submit.prevent="submit"
      )
        +b.el
          +b.g-row--space_xl.rel
            +b.g-cols--12.--6-md.g-cell
              +b.ds-caption--size_xs.--c_black.--w_r {{trans.name}}
              +b.el--p_t_1xs.rel
                input-group.effect-1(
                  rules='required|text'
                  type="text",
                  name="name"
                  v-model="formData.name"
                  :placeholder="trans.name_place"
                )
                  template(v-slot:error="{errors}")
                    transition(name="fade")
                      span.help--type_error(v-if='errors.length') {{ trans.phone_name }}
            +b.g-cols--12.--6-md.g-cell.el--m_t_2xs.--m_t_none-md
              +b.ds-caption--size_xs.--c_black.--w_r {{trans.phone}}
              +b.el--p_t_1xs.rel
                input-group(
                  rules='required|phones|min:9|max:16'
                  type="tel",
                  name="phone"
                  v-model="formData.phone"
                  :placeholder="trans.phone_place"
                )
                  template(v-slot:error="{errors}")
                    transition(name="fade")
                      span.help--type_error(v-if='errors.length') {{ trans.phone_valid }}
            +b.g-cols--12.--6-md.g-cell.el--m_t_2xs.--m_t_sm-md
              +b.ds-caption--size_xs.--c_black.--w_r {{trans.place_from}}
              validation-provider(
                tag="div"
                v-slot="{errors}"
                rules="required"
              )
                +b.el--p_t_1xs.rel
                  +b.ds-control-box
                    +e.body(:class="formData.place_from ? 'is-value': '' ")
                      input.effect-line-input(
                        rules='required'
                        type="text",
                        name="send",
                        ref="origin"
                        v-model="formData.place_from"
                        :placeholder="trans.place_from_p"
                      )
                      span.focus-border
                  +b.g-cols(v-if="errors[0]")
                    +b.P.help--type_error {{trans.place_from_error}}
            +b.g-cols--12.--6-md.g-cell.el--m_t_2xs.--m_t_sm-md
              +b.ds-caption--size_xs.--c_black.--w_r {{trans.place_to}}
              validation-provider(
                tag="div"
                v-slot="{errors}"
                rules="required"
                :placeholder="trans.place_to_p"
              )
                +b.el--p_t_1xs.rel
                  +b.ds-control-box
                    +e.body(:class="formData.place_to ? 'is-value': '' ")
                      input.effect-line-input(
                        rules='required'
                        type="text",
                        name="sendTo",
                        ref="originTo"
                        v-model="formData.place_to"
                        :placeholder="trans.place_to_p"
                      )
                      span.focus-border
                  +b.g-cols(v-if="errors[0]")
                    +b.P.help--type_error {{trans.place_to_error}}
            +b.g-cols--12
              vue-recaptcha(
                ref="recaptcha"
                size="invisible"
                :sitekey="sitekey"
                @verify="submit"
                @expired="onCaptchaExpired"
              )
          +b.g-row--space_xl.rel(
            :class="vision ? 'form--isactive': 'form--inactive'"
          )
            +b.g-cols--12.--6-md.--n_height.g-cell.el--m_t_2xs.--m_t_sm-md.form-wrap
              +b.ds-caption--size_xs.--c_black.--w_r(style="margin-top: 12px") {{trans.email}}
              +b.el--p_t_1xs.rel
                input-group(
                  type="email",
                  name="email"
                  v-model="formData.email"
                  :placeholder="trans.email"
                )
                  template(v-slot:error="{errors}")
                    transition(name="fade")
                      span.help--type_error(v-if='errors.length') {{ trans.email_valid }}
            +b.g-cols--12.--6-md.--n_height.g-cell.el--m_t_2xs.--m_t_sm-md.form-wrap
              +b.SPAN.ds-caption--size_xs.--c_black.--w_r {{trans.size}}
              +b.SPAN.SUP 3
              +b.el--p_t_1xs.rel
                input-group(
                  type="number",
                  name="size"
                  v-model="formData.size"
                  :placeholder="trans.size_place"
                )
                  template(v-slot:error="{errors}")
                    transition(name="fade")
                      span.help--type_error(v-if='errors.length') {{ errors[0] }}
            +b.g-cols--12.--6-md.--n_height.g-cell.el--m_t_2xs.--m_t_sm-md.form-wrap
              +b.ds-caption--size_xs.--c_black.--w_r {{trans.weight}}
              +b.el--p_t_1xs.rel
                input-group(
                  type="number",
                  name="weight"
                  v-model="formData.weight"
                  :placeholder="trans.weight_place"
                )
                  template(v-slot:error="{errors}")
                    transition(name="fade")
                      span.help--type_error(v-if='errors.length') {{ errors[0] }}
        +b.el--p_t_md-md.--p_t_sm
          +b.g-row--justify_between.--align_center
            +b.g-cols--12.--6-md.g-cell
              +b.btn.--max.--white-br.--br(v-if="!vision" @click="hiddenTriggers()")
                +b.g-row.g-cell
                  +b.P.ds-caption--size_md.--size_1xs.--c_lb.--w_b {{trans.btn_top}}
              +b.btn.--max.--white-br.--br(v-else='' @click="hiddenTriggers()")
                +b.g-row.g-cell
                  +b.P.ds-caption--size_md.--size_1xs.--c_lb.--w_b {{trans.btn_top_hidden}}
            +b.g-cols--12.--6-md.g-cell.el--m_t_1xs.--m_t_none-md
              +b.btn.--max.--blue.--br.br-none(@click="validate()")
                +b.g-row.g-cell
                  +b.P.ds-caption--size_md.--size_1xs.--c_white.--w_b {{trans.btn}}
</template>

<script>

import VueRecaptcha from 'vue-recaptcha'
import { submit, openModal, resetForm } from './utils'
import FormRequest from '../services/forms'

export default {
  components: { VueRecaptcha },
  data() {
    return {
      formData: {
        name: '',
        phone: '',
        place_from: '',
        place_to: '',
        email: '',
        size: '',
        weight: '',
        captcha: '',
      },
      autocompleteFrom: '',
      autocompleteTo: '',
      vision: false,
      isLoading: false,
      trans: window.trans,
      sitekey: window.captcha,
      error: window.error,
    }
  },
  props: {
    call: String,
    placeholderEmail: String,
  },
  mounted() {
    window.addEventListener('load', () => {
      // eslint-disable-next-line no-unused-vars,no-undef
      this.autocompleteFrom = new google.maps.places.Autocomplete((this.$refs.origin), { types: ['geocode'] });
      this.autocompleteFrom.addListener('place_changed', () => {
        this.formData.place_from = this.$refs.origin.value
      })
      // eslint-disable-next-line no-unused-vars,no-undef
      this.autocompleteTo = new google.maps.places.Autocomplete((this.$refs.originTo), { types: ['geocode'] });
      this.autocompleteTo.addListener('place_changed', () => {
        this.formData.place_to = this.$refs.originTo.value
      })
    })
  },
  methods: {
    hiddenTriggers() {
      this.vision = !this.vision
    },
    validate() {
      this.$refs.recaptcha.execute()
    },

    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
    },
    async submit(recaptchaToken) {
      const isValid = await submit(this.$refs.observer)
      this.formData.captcha = recaptchaToken
      if (isValid) {
        this.isLoading = true
        FormRequest.getForm(this.formData)
          .then(({ data }) => {
            this.isLoading = false
            this.vision = false
            openModal(this, data.data)
            this.onCaptchaExpired()
            this.formData = resetForm(this.formData)
            requestAnimationFrame(() => {
              this.$refs.observer.reset()
            })
          })
          // eslint-disable-next-line no-unused-vars
          .catch(error => {
            this.isLoading = true
            openModal(this, this.error.data)
            this.isLoading = false
          })
        // eslint-disable-next-line no-empty
      } else {
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/app/Forms/GetForm.vue